import { Modal } from "@JohnLewisPartnership/jl-design-system/dist/components/modal/Modal";
import { UnderlinedButton as V31UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { UnderlinedButton as DeprecatedUnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { Product } from "@~/types/types.ts";
import { useVariant } from "@~/contexts/VariantContext/VariantContext";
import classNames from "classnames/bind";
import styles from "./PromoMessages.module.scss";
import { useFeatureFlags } from "@~/flags/flags";

const cx = classNames.bind(styles);

type Props = {
  product: Product;
  showModal: boolean;
  onClose: () => void;
};

export const PromoModal = ({ product, showModal, onClose }: Props) => {
  const { variant } = useVariant();
  const { isJldsV31Enabled } = useFeatureFlags();

  const promoMessages =
    product.messaging
      ?.filter((m) => m.type === "promotional")
      .map((m) => m.title) || [];

  if (promoMessages.length === 0) {
    return null;
  }

  return (
    <Modal
      className={cx("promoModal")}
      footer={false}
      isOpen={showModal}
      onClose={onClose}
      title="Offers"
    >
      {promoMessages.map((promoMessage) => (
        <p
          key={promoMessage}
          data-testid="product-card-promo-message"
          className={cx("messageSpacing")}
        >
          {promoMessage}
        </p>
      ))}
      {isJldsV31Enabled?.value ? (
        <V31UnderlinedButton
          href={variant?.pdpURL.url || ""}
          tag="a"
          labelText="View full product information"
        />
      ) : (
        <DeprecatedUnderlinedButton href={variant?.pdpURL.url || ""} tag="a">
          View full product information
        </DeprecatedUnderlinedButton>
      )}
    </Modal>
  );
};
